// src/pages/Reports/CurrentLiability/exportCurrentLiabilityCsv.js
import _ from "lodash";

const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const escape = (val) => {
  const str = String(val ?? "");
  return str.includes(",") || str.includes('"') || str.includes("\n")
    ? `"${str.replace(/"/g, '""')}"`
    : str;
};

/**
 * @param {object} params
 * @param {Array}   params.data         - local state `data` (already mapped)
 * @param {number}  params.balanceTotal - local state `balanceTotal`
 * @param {string}  params.title
 * @param {string}  params.filename
 */
export const exportCurrentLiabilityCsv = ({
  data,
  balanceTotal,
  title    = "Current Liability Balance Report",
  filename = "current_liability_balance",
}) => {
  const headers = [
    "No.", "Account Name", "Opening Balance",
    "Debit Amount", "Credit Amount", "Balance",
  ].map(escape);

  const dataRows = data.map((row, i) => [
    i + 1,
    row.acc_name        || "",
    fmt(row.opening_balance),
    fmt(row.debit_total),
    fmt(row.credit_total),
    fmt(row.balance),
  ].map(escape));

  const openingTotal = _.sumBy(data, (r) => Number(r.opening_balance || 0));
  const debitTotal   = _.sumBy(data, (r) => Number(r.debit_total  || 0));
  const creditTotal  = _.sumBy(data, (r) => Number(r.credit_total || 0));

  const totalRow = [
    "Grand Total:", "",
    fmt(openingTotal),
    fmt(debitTotal),
    fmt(creditTotal),
    fmt(balanceTotal),  // 👈 API-provided total, matches table behaviour
  ].map(escape);

  const rows = [[title], [], headers, ...dataRows, [], totalRow];
  const csv  = rows.map((r) => r.join(",")).join("\n");
  const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};